import { hostsConfig } from 'init/config'
import loadCss from 'util/browser/load-css'
import loader from 'util/browser/load-js'

const BASE_JS_ID = 'tt-base-js'
const PAGE_CSS_ID = 'tt-page-css'
const CUSTOM_CSS_ID = 'tt-custom-css'
const PAGE_JS_ID = 'tt-page-js'


let widgetsHostUrl = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}/v5/widgets`
if (process.env.NODE_ENV === 'development' || process.env.testProdBuild) {
  widgetsHostUrl = `${hostsConfig.protocol}://${hostsConfig.widgetsHost}`
}

export default {
  loadPageCss: (cssFilePath) => {
    loadCss(`${widgetsHostUrl}${cssFilePath}`, PAGE_CSS_ID)
  },

  loadCustomCss: (cssFilePath) => {
    loadCss(`${widgetsHostUrl}${cssFilePath}`, CUSTOM_CSS_ID)
  },

  loadBaseJs: (jsFilePath) => {
    loader.loadJs(`${widgetsHostUrl}${jsFilePath}`, BASE_JS_ID)
  },

  loadPageJs: (jsFilePath) => {
    loader.loadJs(`${widgetsHostUrl}${jsFilePath}`, PAGE_JS_ID)
  }
}
